"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _evergreenUi = require("evergreen-ui");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TableHeaderCell = function TableHeaderCell(_ref) {
  var label = _ref.label,
    dataKey = _ref.dataKey,
    width = _ref.width,
    searchable = _ref.searchable,
    value = _ref.value,
    _onChange = _ref.onChange,
    sortable = _ref.sortable,
    columnIndex = _ref.columnIndex,
    sortColumnIndex = _ref.sortColumnIndex,
    ascendingOrder = _ref.ascendingOrder,
    _onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement(_evergreenUi.Table.HeaderCell, {
    flexGrow: width,
    cursor: sortable ? searchable ? "auto" : "pointer" : "auto"
  }, searchable ? /*#__PURE__*/_react["default"].createElement(_evergreenUi.SearchInput, {
    size: 500,
    width: "100%",
    placeholder: "".concat(label),
    border: "muted",
    value: value,
    onChange: function onChange(e) {
      return _onChange(dataKey, e.target.value);
    }
  }) : /*#__PURE__*/_react["default"].createElement(_evergreenUi.Heading, {
    size: 500,
    onClick: sortable ? function () {
      return _onClick(columnIndex);
    } : function () {}
  }, label), sortable && /*#__PURE__*/_react["default"].createElement(_evergreenUi.Pane, {
    paddingLeft: (0, _evergreenUi.majorScale)(1)
  }, /*#__PURE__*/_react["default"].createElement(_evergreenUi.Icon, {
    icon: columnIndex === sortColumnIndex ? ascendingOrder ? "sort-asc" : "sort-desc" : "sort",
    onClick: function onClick() {
      return _onClick(columnIndex);
    },
    cursor: "pointer"
  })));
};
TableHeaderCell.propTypes = {
  label: _propTypes["default"].string.isRequired,
  // Even though dataKey isn’t used when a plain header cell is created, it’s necessary to have it or the corresponding
  // field won’t be shown for this column
  dataKey: _propTypes["default"].string.isRequired,
  width: _propTypes["default"].number,
  searchable: _propTypes["default"].bool,
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  sortable: _propTypes["default"].bool,
  columnIndex: _propTypes["default"].number,
  sortColumnIndex: _propTypes["default"].number,
  ascendingOrder: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
};
TableHeaderCell.defaultProps = {
  width: 1,
  searchable: false,
  value: null,
  onChange: function onChange() {},
  sortable: false,
  columnIndex: 0,
  sortColumnIndex: 0,
  ascendingOrder: false,
  onClick: function onClick() {}
};
var _default = exports["default"] = TableHeaderCell;